(function () {
  /* ---------------- Carousel (featured section) ---------------- */
  function initCarousel(root) {
    if (root.dataset.carouselReady === '1') return;
    root.dataset.carouselReady = '1';

    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');

    function pageSize() {
      return track.clientWidth;
    }
    function update() {
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      var noOverflow = track.scrollWidth <= track.clientWidth + 1;
      if (prev) prev.disabled = track.scrollLeft <= 0;
      if (next) next.disabled = track.scrollLeft >= maxScroll || noOverflow;
    }

    if (next) next.addEventListener('click', function () { track.scrollBy({ left: pageSize(), behavior: 'smooth' }); });
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -pageSize(), behavior: 'smooth' }); });

    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update);

    root._carouselUpdate = update;
    update();
  }

  /* ---------------- Filter + sort + pagination ---------------- */
  function initProducts(root) {
    if (root.dataset.productsReady === '1') return;
    root.dataset.productsReady = '1';

    var section = root.closest('#products') || document;
    var bar = section.querySelector('[data-filter]');
    var track = root.querySelector('[data-products-grid]');
    if (!track) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-product]'));
    var countEl = bar ? bar.querySelector('[data-filter-count]') : null;
    var emptyEl = section.querySelector('[data-filter-empty]');
    var sortSel = bar ? bar.querySelector('[data-sort]') : null;
    var searchInput = bar ? bar.querySelector('[data-filter-search]') : null;
    var pagerEl = root.querySelector('[data-products-pagination]');
    var pageSize = Math.max(1, parseInt(root.dataset.pageSize || '8', 10));
    var currentPage = 1;
    var searchTimer;
    var matched = cards.slice();
    var labelPrev = (pagerEl && pagerEl.dataset.labelPrev) || 'Previous';
    var labelNext = (pagerEl && pagerEl.dataset.labelNext) || 'Next';

    function activeFacets() {
      var f = {};
      if (!bar) return f;
      bar.querySelectorAll('select[data-facet]').forEach(function (s) {
        if (s.value) f[s.dataset.facet] = s.value;
      });
      var use = [];
      bar.querySelectorAll('input[type="checkbox"][data-facet="use"]:checked').forEach(function (c) {
        use.push(c.value);
      });
      if (use.length) f.use = use;
      return f;
    }

    function searchQuery() {
      return searchInput ? (searchInput.value || '').trim().toLowerCase() : '';
    }

    function matchesSearch(card, q) {
      if (!q) return true;
      var title = (card.dataset.title || '').toLowerCase();
      var brand = (card.dataset.brand || '').toLowerCase();
      return title.indexOf(q) !== -1 || brand.indexOf(q) !== -1;
    }

    function matches(card, f) {
      for (var key in f) {
        var val = f[key];
        if (key === 'price') {
          var parts = val.split('-');
          var p = parseInt(card.dataset.price || '0', 10);
          if (p < parseInt(parts[0], 10) || p > parseInt(parts[1], 10)) return false;
        } else if (key === 'avail') {
          if ((card.dataset.available || '0') !== val) return false;
        } else if (key === 'use') {
          var cu = card.dataset.use || '';
          var hit = val.some(function (u) { return cu.indexOf(u) !== -1; });
          if (!hit) return false;
        } else if (key === 'cat') {
          var cc = '|' + (card.dataset.cat || '') + '|';
          if (cc.indexOf('|' + val + '|') === -1) return false;
        } else {
          if ((card.dataset[key] || '') !== val) return false;
        }
      }
      return true;
    }

    function sortCards(list) {
      var mode = sortSel ? sortSel.value : 'manual';
      var arr = list.slice();
      if (mode === 'price-asc') arr.sort(function (a, b) { return (+a.dataset.price) - (+b.dataset.price); });
      else if (mode === 'price-desc') arr.sort(function (a, b) { return (+b.dataset.price) - (+a.dataset.price); });
      else if (mode === 'title-asc') arr.sort(function (a, b) { return (a.dataset.title || '').localeCompare(b.dataset.title || ''); });
      else if (mode === 'title-desc') arr.sort(function (a, b) { return (b.dataset.title || '').localeCompare(a.dataset.title || ''); });
      return arr;
    }

    function totalPages() {
      return Math.max(1, Math.ceil(matched.length / pageSize));
    }

    function renderPager() {
      if (!pagerEl) return;
      var pages = totalPages();
      if (matched.length === 0 || pages <= 1) {
        pagerEl.hidden = true;
        pagerEl.innerHTML = '';
        return;
      }

      pagerEl.hidden = false;
      var html = '';
      html +=
        '<button type="button" class="gh-shop__page-btn" data-page-nav="prev"' +
        (currentPage <= 1 ? ' disabled' : '') +
        ' aria-label="' +
        labelPrev +
        '">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>' +
        '</button>';

      for (var i = 1; i <= pages; i++) {
        html +=
          '<button type="button" class="gh-shop__page-btn' +
          (i === currentPage ? ' is-active' : '') +
          '" data-page="' +
          i +
          '" aria-label="Page ' +
          i +
          '"' +
          (i === currentPage ? ' aria-current="page"' : '') +
          '>' +
          i +
          '</button>';
      }

      html +=
        '<button type="button" class="gh-shop__page-btn" data-page-nav="next"' +
        (currentPage >= pages ? ' disabled' : '') +
        ' aria-label="' +
        labelNext +
        '">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>' +
        '</button>';

      pagerEl.innerHTML = html;
    }

    function paintPage() {
      var pages = totalPages();
      if (currentPage > pages) currentPage = pages;
      if (currentPage < 1) currentPage = 1;

      var start = (currentPage - 1) * pageSize;
      var end = start + pageSize;

      cards.forEach(function (card) {
        card.classList.add('is-hidden');
      });

      matched.forEach(function (card, index) {
        var onPage = index >= start && index < end;
        card.classList.toggle('is-hidden', !onPage);
        if (onPage) track.appendChild(card);
      });

      if (countEl) countEl.textContent = matched.length;
      if (emptyEl) emptyEl.hidden = matched.length !== 0;
      renderPager();
    }

    function apply(resetPage) {
      var f = activeFacets();
      var q = searchQuery();
      matched = sortCards(
        cards.filter(function (card) {
          return matches(card, f) && matchesSearch(card, q);
        })
      );
      if (resetPage !== false) currentPage = 1;
      paintPage();
    }

    if (bar) {
      bar.addEventListener('change', function () {
        apply(true);
      });
    }
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(function () {
          apply(true);
        }, 120);
      });
      searchInput.addEventListener('search', function () {
        apply(true);
      });
    }

    if (pagerEl) {
      pagerEl.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-page], [data-page-nav]');
        if (!btn || btn.disabled) return;
        if (btn.hasAttribute('data-page-nav')) {
          if (btn.getAttribute('data-page-nav') === 'prev') currentPage -= 1;
          else currentPage += 1;
        } else {
          currentPage = parseInt(btn.getAttribute('data-page'), 10) || 1;
        }
        paintPage();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    apply(true);
  }

  function scrollToProductsHash() {
    if (window.location.hash !== '#products') return;
    var target = document.getElementById('products');
    if (!target) return;
    requestAnimationFrame(function () {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-carousel]').forEach(initCarousel);
    document.querySelectorAll('[data-products]').forEach(initProducts);
    scrollToProductsHash();
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  window.addEventListener('load', scrollToProductsHash);
  document.addEventListener('shopify:section:load', initAll);
})();
